import { DateRangeFilterValue, Value } from "@homebound/beam";
import { Bill, BillType } from "src/generated/graphql-types";
import { DeepPartial } from "src/utils";

export type InvoicesFilter = {
  address: string[];
  status: string[];
  createdDateRange: DateRangeFilterValue<Value> | undefined;
  paidDateRange: DateRangeFilterValue<Value> | undefined;
  marketId: string[] | undefined;
};

export function getInvoicePrefix(bill: DeepPartial<Bill>, hidePrefix: boolean = false) {
  if (bill.type?.code === BillType.Deposit) return "Deposit";
  if (hidePrefix) return "";
  return "Invoice";
}
